








import { computed, defineComponent, PropType, toRefs } from "@vue/composition-api"
import { GiftTaskConfigItem } from "../../config"

export default defineComponent({
  name: "GiftTaskItem",
  props: {
    taskConfig: {
      type: Object as PropType<GiftTaskConfigItem>,
      required: true
    },
    selectedTab: {
      type: Object as PropType<GiftTaskConfigItem>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { taskConfig, selectedTab } = toRefs(props)

    const handleClick = () => emit("click", taskConfig.value)
    const isActivated = computed(
      () =>
        selectedTab.value.taskId === taskConfig.value.taskId &&
        selectedTab.value.groupId === taskConfig.value.groupId &&
        selectedTab.value.offerId === taskConfig.value.offerId
    )
    return {
      isActivated,
      handleClick
    }
  }
})
